import K from '../constants';
import restHelpers from '../helpers/restHelper';

export default {
  get: (carId, startDate, endDate) => restHelpers.withBearer.get(`${K.API_URL}/journeys/cars/${carId}/${startDate}/${endDate}`, {}),
  getAll: (startDate, endDate, size = 3, page = 1, sort = 'newest', search, cars) =>
    restHelpers.withBearer.get(
      `${K.API_URL}/journeys/${startDate}/${endDate}?_=${new Date().getTime()
      }&size=${size
      }&page=${page
      }&sort=${sort
      }${search? `&search=${search}`: ''}${cars && cars.length > 0 ? cars.map(car => `&cars[]=${car}`).join('') : ''}`,
      {}
      ),
  oneDay: (carId, when) => restHelpers.withBearer.get(`${K.API_URL}/journeys/cars/${carId}/${when}`, {}),
  update: (journeyId, journey) =>restHelpers.withBearer.put(`${K.API_URL}/journeys/${journeyId}`, {data: journey}),
};



// WEBPACK FOOTER //
// ./src/services/journeys.js